import { QuestionMarkOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { ScheduleLine } from '../types/models'
import { lang } from '../utils/lang'
import { ActivityIcon } from '../components/atoms/ActivityIcon'

export const ScheduleLineView = ({ line }: { line: ScheduleLine }): JSX.Element => {
  const { t } = useTranslation()

  const time = DateTime.fromISO(line[0])
  const { name, value } = line[1]

  let icon = <QuestionMarkOutlined sx={{ color: 'red', fontSize: '90%' }}/>
  let text = t('Unknown scheduled event')

  switch (name) {
    case 'is_on':
      if (value) {
        icon = <ActivityIcon type="RELAY_ON"/>
        text = t('Turn appliance ON')
      } else {
        icon = <ActivityIcon type="RELAY_OFF"/>
        text = t('Turn appliance OFF')
      }
      break
  }

  return <Box sx={{ display: 'flex' }}>
    <Box>{lang.dayNameLong(time.weekday)}</Box>
    <Box sx={{ mx: 2 }}>{time.toLocal().toFormat('HH:mm:ss')}</Box>
    {icon}
    <Box sx={{ ml: 2 }}>{text}</Box>
  </Box>
}
